@if (!hasP00031()) {
  <app-small-tuile
    type="icon"
    icon="fa-kit fa-picto-eclairage"
    [title]="'dashboard.lighting' | translate"
    [content]="
      buttons[this.actionStack!.getValue('eclairageStandardSCommandeEclairage')]
        .icon!
    "
    [color]="
      buttons[this.actionStack!.getValue('eclairageStandardSCommandeEclairage')]
        .color!
    "
    [status]="
      buttons[this.actionStack!.getValue('eclairageStandardSCommandeEclairage')]
        .title! | translate
    "
    [statusMode]="
      buttons[this.actionStack!.getValue('eclairageStandardSCommandeEclairage')]
        .status!
    "
    (onPress)="this.openProductModal()"
  >
  </app-small-tuile>
}
